<template>
  <div class="dash-page" style="padding:20px;background:#f8fafc;min-height:100vh;width:100%;">
    <div style="max-width:1400px;width:100%;margin:0 auto;">

      <!-- HEADER -->
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;flex-wrap:wrap;gap:15px;">
        <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;">
          <h2 class="page-title">{{ $t($route.name) }}</h2>
          <router-link v-if="settedrule.open" :to="{ path: '/chiqim/create' }" class="action-btn primary-btn">
            <b-icon icon="cart-plus"></b-icon> {{ $t("Савдо ойна") }}
          </router-link>
          <button type="button" class="action-btn outline-btn" @click="ClientPay()">
            <b-icon icon="credit-card"></b-icon> {{ $t("Тўлов") }}
          </button>
          <!-- Litsenziya muddatini billing'dan qayta o'qib, bazadagi sklad vaqtini yangilaydi -->
          <button type="button" class="action-btn outline-btn" :disabled="time_loading" @click="Updatetime()">
            <b-icon icon="arrow-repeat"></b-icon> {{ $t("Янгилаш") }}
          </button>
          <span class="license-badge"
            :class="{ 'danger': (end_date - new Date().valueOf().toString().slice(0, 10)) < 259200 }">
            {{ $t('До') + " " + Datetime(end_date) }}
          </span>
        </div>
        <div style="display:flex;align-items:center;gap:8px;">
          <div class="date-input-wrap">
            <input type="date" v-model="datetime1" @change="Change()" />
          </div>
          <span style="color:#cbd5e1;font-weight:600;">—</span>
          <div class="date-input-wrap">
            <input type="date" v-model="datetime2" @change="Change()" />
          </div>
          <top></top>
        </div>
      </div>

      <!-- GRAFIKLAR -->
      <div style="display:flex;gap:20px;margin-bottom:20px;flex-wrap:wrap;">
        <div class="chart-card" style="flex:1;min-width:300px;">
          <apexchart type="bar" ref="toptovar" height="300" :options="chartOptions3" :series="series3"></apexchart>
        </div>
        <div class="chart-card" style="flex:1;min-width:300px;">
          <apexchart type="line" ref="dollar" height="300" :options="chartOptions" :series="series"></apexchart>
        </div>
      </div>

      <!-- JADVALLAR -->
      <div style="display:flex;gap:20px;flex-wrap:wrap;">
        <!-- Tovar qoldiq -->
        <div class="data-card" style="flex:1;min-width:300px;">
          <div class="data-card-header">
            <div class="data-card-title">
              <b-icon icon="box-seam"></b-icon>
              <span>{{ $t('Товар остаток') }}</span>
            </div>
            <button type="button" class="tool-btn" @click="downloadExcel">
              <b-icon icon="cloud-download"></b-icon> Excel
            </button>
          </div>
          <div style="overflow-y:auto;max-height:calc(100vh - 500px);">
            <table class="data-table" id="product_table">
              <thead>
                <tr>
                  <th style="width:50px">#</th>
                  <th>{{ $t('Номи') }}</th>
                  <th style="width:100px;text-align:right;">{{ $t('Қолдиқ') }}</th>
                  <th style="width:80px;text-align:right;">Мин.</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in minimal" :key="index">
                  <td><span class="id-badge">{{ index + 1 }}</span></td>
                  <td style="font-weight:700;">{{ item.extra_name }}</td>
                  <td style="text-align:right;">{{ item.count | numFormats }}</td>
                  <td style="text-align:right;color:#e11d48;font-weight:600;">{{ item.minimum_amount | numFormats }}</td>
                </tr>
                <tr v-if="minimal.length === 0">
                  <td colspan="4" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Kontragent to'lov -->
        <div class="data-card" style="flex:1;min-width:300px;">
          <div class="data-card-header">
            <div class="data-card-title">
              <b-icon icon="people"></b-icon>
              <span>{{ $t('Контрагент') }} {{ $t('Тўлов').toLowerCase() }}</span>
            </div>
          </div>
          <div style="overflow-y:auto;max-height:calc(100vh - 500px);">
            <table class="data-table">
              <thead>
                <tr>
                  <th style="width:50px">#</th>
                  <th>{{ $t('Номи') }}</th>
                  <th style="width:100px;text-align:center;">{{ $t('Вақт') }}</th>
                  <th style="width:110px;text-align:right;">So'm</th>
                  <th style="width:110px;text-align:right;">Dollar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in kontragenttime" :key="index">
                  <td><span class="id-badge">{{ index + 1 }}</span></td>
                  <td style="font-weight:700;">{{ item.name }}</td>
                  <td style="text-align:center;">{{ SetDatetime(item.payment_date) }}</td>
                  <td style="text-align:right;">{{ item.total | numFormat }}</td>
                  <td style="text-align:right;color:#16a34a;font-weight:700;">{{ item.total_dollar | numFormat }}</td>
                </tr>
                <tr v-if="kontragenttime.length === 0">
                  <td colspan="5" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr style="background:#f8fafc;">
                  <td colspan="3" style="padding:12px 15px;border-top:2px solid #f1f2f6;"><strong>Jami</strong></td>
                  <td style="text-align:right;padding:12px 15px;border-top:2px solid #f1f2f6;"><strong>{{ kontragenttimesumm.som | numFormat }}</strong></td>
                  <td style="text-align:right;padding:12px 15px;border-top:2px solid #f1f2f6;color:#16a34a;"><strong>{{ kontragenttimesumm.dollar | numFormat }}</strong></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>

    </div>

    <!-- TO'LOV MODAL -->
    <b-modal id="modal-pay" hide-footer size="md" @shown="FocusToSecret" modal-class="modern-modal">
      <div class="modal-form">
        <div class="form-unit">
          <label>{{ $t("ИД рақам") }} <sup class="text-danger">*</sup></label>
          <input ref="secretcode" type="text" class="form-input" v-model="pay.SecretCode" @blur="CheckSecretCode()">
          <small v-if="check_Secret_code" class="text-danger">{{ $t("ИД рақамни тўлдириш шарт") }}</small>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-unit">
              <label>Klient</label>
              <div class="form-input readonly">{{ pay.projectOwner }}</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-unit">
              <label>{{ $t("Ижара суммаси") }}</label>
              <div class="form-input readonly text-right">{{ pay.rentalPrice | numFormat }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- Billing payment_Method: 0 = KUNLIK, 1 = OYLIK (Login.vue/PROFCARUZ bilan bir xil) -->
          <div class="col-md-6" v-if="pay.payment_Method == 0">
            <div class="form-unit">
              <label>{{ $t("Кун") }}</label>
              <input type="number" min="1" class="form-input" v-model="pay.day" @change="Summa()">
            </div>
          </div>
          <div class="col-md-6" v-if="pay.payment_Method == 1">
            <div class="form-unit">
              <label>{{ $t("Ой") }}</label>
              <input type="number" min="1" class="form-input" v-model="pay.month" @change="Summa()">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-unit">
              <label>{{ $t("Тўлов") }} summa</label>
              <div class="form-input readonly text-right">{{ pay.amount | numFormat }}</div>
            </div>
          </div>
        </div>
        <div class="form-unit">
          <label>{{ $t("Карта рақами") }} <sup class="text-danger">*</sup></label>
          <input type="text" class="form-input" placeholder="0000 0000 0000 0000" v-model="pay.cardNumber">
          <small v-if="check_card_number" class="text-danger">{{ $t("Карта рақамни тўлдириш шарт") }}</small>
        </div>
        <div class="form-unit">
          <label>{{ $t("Карта муддати (ой/йил)") }} <sup class="text-danger">*</sup></label>
          <input type="text" placeholder="08/29" maxlength="5" class="form-input" v-model="pay.expireDate">
        </div>
        <div class="row" style="align-items: flex-end;">
          <div class="col-md-3">
            <button type="button" class="action-btn primary-btn" style="width:100%;margin-top:20px;"
              :disabled="sms_loading" @click="SendSms()">
              {{ sms_loading ? '...' : 'SMS kod' }}
            </button>
          </div>
          <div class="col-md-9">
            <div class="form-unit">
              <label>SMS kod <sup class="text-danger">*</sup></label>
              <input type="text" placeholder="123456" class="form-input" v-model="pay.otp">
              <small v-if="check_otp" class="text-danger">{{ $t("Смс кодни тўлдириш шарт") }}</small>
            </div>
          </div>
        </div>
        <!-- Billing (1C) qaytargan xato shu yerda ko'rinadi -->
        <div v-if="pay_error" class="pay-alert">
          <b-icon icon="exclamation-triangle-fill" class="mr-1"></b-icon>
          <span>{{ pay_error }}</span>
          <div v-if="pay_hint" class="pay-alert-hint">{{ pay_hint }}</div>
        </div>
        <div class="modal-actions">
          <button type="button" class="btn-save-full" :disabled="pay_loading" @click="SendPay()">
            <b-icon icon="check-all" class="mr-1"></b-icon> {{ $t("Тўлов қилиш") }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { print } from "../components/mixins/print.js";
import $ from "jquery";
import Top from "./Layout/Top.vue";
var XLSX = require("xlsx");
var FileSaver = require("file-saver");
import {
  StatsCard,
  ChartCard,
  NavTabsCard,
  NavTabsTable,
  OrderedTable
} from "@/components";

export default {
  components: {
    Top,
    StatsCard,
    ChartCard,
    NavTabsCard,
    NavTabsTable,
    OrderedTable
  },
  mixins: [print],
  methods: {
    Change() {
      this.Minimum();
      this.Kontragenttime();
      this.Dollar();
      this.Producttop();
    },
    Minimum() {
      let self = this;
      axios({
        method: "post",
        url: "api/v1/report/product-min",
        data: {
          datetime1: parseInt(new Date(self.datetime1).valueOf().toString().slice(0, 10)),
          datetime2: parseInt(new Date(self.datetime2).valueOf().toString().slice(0, 10)),
          sklad_id: parseInt(localStorage.getItem("sklad_id"))
        }
      }).then(function (response) {
        self.minimal = response.data;
      });
    },
    Producttop() {
      let self = this;
      var dataall = [];
      axios({
        method: "post",
        url: "api/v1/report/product-top",
        data: {
          datetime1: parseInt(new Date(self.datetime1).valueOf().toString().slice(0, 10)),
          datetime2: parseInt(new Date(self.datetime2).valueOf().toString().slice(0, 10)),
          sklad_id: parseInt(localStorage.getItem("sklad_id")),
          limit: 20
        }
      }).then(function (response) {
        // self.series3[0].data=[];
        // self.chartOptions3.xaxis.categories=[];
        // self.producttop=response.data;
        response.data.forEach(element => {
          self.series3[0].data.push(element.count);
          dataall.push(element.extra_name);
        });
        self.$refs.toptovar.updateOptions({
          xaxis: {
            categories: dataall
          }
        });
      });
    },
    SetDatetime(date) {
      if (date > 0) {
        var d = new Date(date * 1000);
        var dt = d.getDate();
        var hour = d.getHours();
        var minut = d.getMinutes();
        var month = d.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        if (minut < 10) {
          minut = "0" + minut;
        }
        if (hour < 10) {
          hour = "0" + hour;
        }
        if (dt < 10) {
          dt = "0" + dt;
        }
        // return d.getFullYear()+ "-" + month + "-" + dt +'T'+hour+':'+minut;
        return dt + '-' + month + '-' + d.getFullYear();
      } else {
        return "";
      }
    },
    Kontragenttime() {
      let self = this;
      axios({
        method: "post",
        url: "api/v1/report/kontragent-payment-date",
        data: {
          datetime1: parseInt(new Date(self.datetime1).valueOf().toString().slice(0, 10)),
          datetime2: parseInt(new Date(self.datetime2).valueOf().toString().slice(0, 10)),
          sklad_id: parseInt(localStorage.getItem("sklad_id"))
        }
      }).then(function (response) {
        self.kontragenttime = response.data;
        self.kontragenttimesumm.som = 0;
        self.kontragenttimesumm.dollar = 0;
        response.data.forEach(element => {
          self.kontragenttimesumm.som += element.total;
          self.kontragenttimesumm.dollar += element.total_dollar;
        });
      });
    },
    Dollar() {
      let self = this;
      let datas = [];
      axios({
        method: "get",
        url: "api/v1/dollar-exchange-rate"
      }).then(function (response) {
        response.data.forEach(element => {
          self.series[0].data.push(element.rate);
          datas.push(self.SetDatetime(element.datetime));
        });
        // self.$refs.realtimeChart.updateSeries([{
        //   data: this.series[0].data,
        // }], false, true);
        self.$refs.dollar.updateOptions({
          xaxis: {
            categories: datas
          }
        });
      });
    },
    ClientPay() {
      this.pay_error = "";
      this.pay_hint = "";
      // Tugallanmagan tranzaksiya sessiyasini tiklash: SMS olingandan keyin
      // sahifa yangilansa ham OTP ni kiritib to'lovni tugatish mumkin bo'lsin
      // (aks holda billing "Транзакция существует" deb qaytaradi va yo'l berkiladi).
      try {
        const saved = JSON.parse(localStorage.getItem("pay_session") || "null");
        if (saved && saved.session && (Date.now() - saved.ts) < 15 * 60 * 1000) {
          this.pay.session = saved.session;
          this.pay.SecretCode = saved.SecretCode || this.pay.SecretCode;
          this.pay.day = saved.day;
          this.pay.month = saved.month;
          this.pay.amount = saved.amount;
          this.pay_hint = this.$t("Тугалланмаган тўлов мавжуд: СМС кодни киритиб тасдиқланг");
        } else if (saved) {
          localStorage.removeItem("pay_session");
        }
      } catch (e) {
        localStorage.removeItem("pay_session");
      }
      this.$bvModal.show("modal-pay");
      if (this.pay.SecretCode) this.CheckSecretCode();
    },
    FocusToSecret() {
      this.$refs.secretcode.focus();
    },
    // Billing xatosini modal ichida ham, umumiy alert'da ham ko'rsatamiz
    PayError(message) {
      const msg = message || this.$t('no contact with the site');
      this.pay_error = msg;
      this.$store.state.errors = msg;
      // 1C "Транзакция существует" — oldingi tranzaksiya hali yopilmagan
      if (/существу|мавжуд/i.test(String(msg))) {
        this.pay_hint = this.$t("Олдинги тўлов тугалланмаган: телефонга келган СМС кодни киритиб 'Тўлов қилиш'ни босинг ёки 10-15 дақиқадан сўнг қайта уриниб кўринг");
      }
    },
    // Bazadagi sklad vaqtini (datetime1/datetime2) billing'dan qayta o'qib yozadi
    Updatetime() {
      let self = this;
      self.time_loading = true;
      axios({
        method: "post",
        url: "api/v1/sklads/update-datetime",
        data: {
          sklad_id: parseInt(localStorage.getItem("sklad_id")) || 1
        }
      }).then(function (response) {
        self.time_loading = false;
        const d = response.data || {};
        if (d.datetime2) self.end_date = d.datetime2;
        else self.Sklad(); // badge'ni bazadan qayta o'qiymiz
        self.$bvToast.toast(self.$t('Муддат янгиланди') + (d.datetime2 ? ': ' + self.Datetime(d.datetime2) : ''), {
          title: self.$t('Муваффаққиятли'),
          toaster: 'b-toaster-bottom-center',
          variant: 'success',
          solid: true
        });
      }).catch(function (error) {
        self.time_loading = false;
        const r = (error.response && error.response.data) || {};
        self.$store.state.errors = r.message || self.$t('no contact with the site');
      });
    },
    CheckSecretCode() {
      let self = this;
      if (self.pay.SecretCode != "") {
        self.check_Secret_code = false;
        // Billing (1C HTTP-service) ga backend PROXY orqali — to'g'ridan emas
        // (sayt HTTPS, billing HTTP → mixed-content; auth server tomonda).
        axios
          .post("api/v1/registration/check-secret-code", {
            SecretCode: self.pay.SecretCode,
          })
          .then(function (response) {
            const r = response.data || {};
            if (r.error == false && r.data) {
              self.pay.projectOwner = r.data.projectOwner;
              self.pay.rentalPrice = r.data.rentalPrice;
              self.pay.payment_Method = r.data.payment_Method;
            } else {
              self.$store.state.errors = (r.data && r.data.answer) || r.message || self.$t('no contact with the site');
            }
          })
          .catch(function () {
            self.$store.state.errors = self.$t('no contact with the site');
          });
      } else {
        self.check_Secret_code = true;
      }
    },
    Summa() {
      if (this.pay.SecretCode != "") {
        if (this.pay.payment_Method == 0) {
          // payment_Method 0 = KUNLIK to'lov (ijara summasi — 1 kunlik narx)
          this.pay.amount = this.pay.day * this.pay.rentalPrice;
          this.pay.day = parseInt(this.pay.day);
          this.pay.month = 0;
        } else if (this.pay.payment_Method == 1) {
          // payment_Method 1 = OYLIK to'lov
          this.pay.amount = this.pay.month * this.pay.rentalPrice;
          this.pay.month = parseInt(this.pay.month);
          this.pay.day = 0;
        }
      } else {
        this.check_Secret_code = true;
      }
    },
    SendSms() {
      let self = this;
      if (self.sms_loading) return;
      if (self.pay.cardNumber != "") {
        self.check_card_number = false;
        self.pay_error = "";
        // Tekshiruvlar: bo'sh/noto'g'ri ma'lumot billing'da keraksiz tranzaksiya yaratmasin
        if (!self.pay.SecretCode) { self.check_Secret_code = true; return; }
        if (!self.pay.amount || self.pay.amount <= 0) {
          self.PayError(self.$t("Тўлов суммаси нол: кун/ой сонини киритинг"));
          return;
        }
        // Ochiq (tugallanmagan) tranzaksiya bo'lsa — billing "Транзакция существует" beradi
        if (self.pay.session) {
          const ok = window.confirm(self.$t("СМС код аллақачон юборилган. Янги транзакция очишни хоҳлайсизми?"));
          if (!ok) return;
        }
        // Karta raqami — faqat raqamlar (probel/chiziqsiz)
        const cardDigits = String(self.pay.cardNumber || '').replace(/\D/g, '');
        // Amal muddati — billing YYMM (yil+oy) kutadi. Foydalanuvchi kartadagidek
        // MM/YY ("08/29") kiritadi → YYMM ("2908") ga aylantiramiz.
        // (a>12 bo'lsa allaqachon YYMM — oy 12 dan katta bo'lolmaydi.)
        const expRaw = String(self.pay.expireDate || '').replace(/\D/g, '');
        let expireYYMM = expRaw;
        if (expRaw.length === 4) {
          const a = parseInt(expRaw.slice(0, 2), 10);
          const b = parseInt(expRaw.slice(2, 4), 10);
          expireYYMM = (a > 12 && b >= 1 && b <= 12) ? expRaw : (expRaw.slice(2, 4) + expRaw.slice(0, 2));
        }
        // Kartadan to'lov + SMS jo'natish — backend PROXY orqali.
        self.sms_loading = true;
        axios
          .post("api/v1/registration/payment-site-card", {
            SecretCode: self.pay.SecretCode,
            cardNumber: cardDigits,
            expireDate: expireYYMM,
            day: parseInt(self.pay.day) || 0,
            month: parseInt(self.pay.month) || 0,
            amount: self.pay.amount,
          })
          .then(function (response) {
            self.sms_loading = false;
            const r = response.data || {};
            if (r.error == false && r.data) {
              self.pay.session = r.data.session;
              self.pay_error = "";
              self.pay_hint = "";
              // Sessiyani saqlaymiz — sahifa yangilansa ham OTP bilan tugatish mumkin
              localStorage.setItem("pay_session", JSON.stringify({
                session: r.data.session,
                SecretCode: self.pay.SecretCode,
                day: self.pay.day,
                month: self.pay.month,
                amount: self.pay.amount,
                ts: Date.now()
              }));
              self.$bvToast.toast(self.$t('Смс код жўнатилди'), {
                title: self.$t('Муваффаққиятли'),
                toaster: 'b-toaster-bottom-center',
                variant: 'success',
                solid: true
              });
            } else {
              self.PayError(r.message);
            }
          })
          .catch(function (error) {
            self.sms_loading = false;
            const r = (error.response && error.response.data) || {};
            self.PayError(r.message);
          });
      } else {
        self.check_card_number = true;
      }
    },
    SendPay() {
      let self = this;
      if (self.pay_loading) return;

      if (self.pay.otp != "") {
        self.check_otp = false;
        self.pay_error = "";
        if (!self.pay.session) {
          self.PayError(self.$t("Аввал 'SMS kod' тугмасини босиб код олинг"));
          return;
        }
        // To'lovni tasdiqlash (OTP) — backend PROXY orqali. Backend muvaffaqiyatda
        // bazadagi sklad.datetime1/datetime2 ni billing'dan qayta o'qib yozadi
        // (header badge shu qiymatni o'qiydi).
        self.pay_loading = true;
        axios
          .post("api/v1/registration/confirm-payment", {
            SecretCode: self.pay.SecretCode,
            session: self.pay.session,
            otp: self.pay.otp,
          })
          .then(function (response) {
            self.pay_loading = false;
            const r = response.data || {};
            if (r.error == false && r.data) {
              self.$bvModal.hide("modal-pay");
              localStorage.removeItem("pay_session");
              self.pay_error = "";
              self.pay_hint = "";
              let date = r.data.date ? r.data.date.slice(0, 10) : "";
              // Badge'ni darhol yangilash: backend bazaga yozgan qiymat ustun,
              // bo'lmasa billing javobidagi unixTime ("1785452400") ishlatiladi.
              // (r.data.date "31.07.2026 0:00:00" formatida — new Date() uni o'qiy olmaydi.)
              if (r.local_datetime2) {
                self.end_date = parseInt(r.local_datetime2);
              } else if (r.data.unixTime) {
                self.end_date = parseInt(r.data.unixTime);
              }
              self.Sklad(); // bazadagi sklad vaqtini qayta o'qiymiz
              self.$bvToast.toast(self.$t('Тўлов қилинди! Кейинги тўлов санаси: ') + date, {
                title: self.$t('Муваффаққиятли'),
                toaster: 'b-toaster-bottom-center',
                variant: 'success',
                solid: true
              });
              self.pay.SecretCode = "";
              self.pay.projectOwner = "";
              self.pay.rentalPrice = 0;
              self.pay.payment_Method = 0;
              self.pay.cardNumber = "";
              self.pay.expireDate = "";
              self.pay.day = null;
              self.pay.month = null;
              self.pay.amount = 0;
              self.pay.otp = "";
              self.pay.session = null;
            } else {
              self.PayError(r.message);
            }
          })
          .catch(function (error) {
            self.pay_loading = false;
            const r = (error.response && error.response.data) || {};
            self.PayError(r.message);
          });
      } else {
        self.check_otp = true;
      }
    },
    downloadExcel() {
      let wb = XLSX.utils.table_to_book(document.getElementById("product_table")),
        wopts = {
          bookType: "xlsx",
          bookSST: false,
          type: "binary"
        };
      var wscols = [{ width: 8 }, { width: 40 }, { width: 13 }, { width: 13 }];
      wb.Sheets.Sheet1['!cols'] = wscols;
      let wbout = XLSX.write(wb, wopts);
      FileSaver.saveAs(
        new Blob([this.s2aab(wbout)], {
          type: "application/octet-stream;charsetted=utf-8"
        }),
        new Date() + "tovar_ostatka.xlsx"
      );
    },
    s2aab(s) {
      if (typeof ArrayBuffer !== "undefined") {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      } else {
        var buf = new Array(s.length);
        for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
    },
  },
  mounted: function () {
    let self = this;
    self.Minimum();
    self.Kontragenttime();
    self.Dollar();
    self.Producttop();
    self.SetRule('/chiqim/index');
  },
  data() {
    return {
      pay: {
        SecretCode: "",
        projectOwner: "",
        rentalPrice: 0,
        payment_Method: 0,
        cardNumber: "",
        expireDate: "",
        day: null,
        month: null,
        amount: 0,
        otp: "",
        session: null
      },
      check_Secret_code: false,
      check_card_number: false,
      check_otp: false,
      pay_error: "",
      pay_hint: "",
      sms_loading: false,
      pay_loading: false,
      time_loading: false,
      kontragenttime: [],
      kontragenttimesumm: { som: 0, dollar: 0 },
      minimal: [],
      producttop: [],
      datetime1: new Date().toISOString().slice(0, 8) + "01",
      datetime2: new Date().toISOString().slice(0, 10),
      series: [{
        name: "Доллар курс",
        data: []
      }],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Доллар курс',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: [],
        }
      },
      series3: [{
        data: []
      }],
      chartOptions3: {
        chart: {
          type: 'bar',
          height: 350
        },
        title: {
          text: 'Топ товар'
        },
        annotations: {
          xaxis: [{
            x: 500,
            borderColor: '#00E396',
            label: {
              borderColor: '#00E396',
              style: {
                color: '#fff',
                background: '#00E396',
              },
              text: 'X annotation',
            }
          }],
          yaxis: [{
            y: 'July',
            y2: 'September',
            label: {
              text: 'Y annotation'
            }
          }]
        },
        plotOptions: {
          bar: {
            horizontal: true,
          }
        },
        dataLabels: {
          enabled: true
        },
        xaxis: {
          categories: [],
        },
        grid: {
          xaxis: {
            lines: {
              show: true
            }
          }
        },
        yaxis: {
          reversed: true,
          axisTicks: {
            show: true
          }
        }
      },
    };
  }
};
</script>

<style scoped>
.page-title {
  color: #a142f4 !important;
  font-weight: 800 !important;
  font-size: 26px !important;
  margin: 0 !important;
}

.action-btn {
  height: 40px;
  padding: 0 18px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: 0.2s;
  text-decoration: none !important;
  white-space: nowrap;
}

.primary-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%) !important;
  color: white !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
}

.primary-btn:hover {
  transform: translateY(-1px);
  color: white !important;
}

.outline-btn {
  background: white !important;
  border: 1px solid #e2e8f0 !important;
  color: #64748b !important;
}

.outline-btn:hover {
  border-color: #a142f4 !important;
  color: #a142f4 !important;
}

.license-badge {
  background: #f0fdf4;
  color: #16a34a;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid #dcfce7;
}

.license-badge.danger {
  background: #fff1f2;
  color: #e11d48;
  border-color: #fecdd3;
}

.date-input-wrap input {
  background: white !important;
  border: 1px solid #e2e8f0 !important;
  padding: 8px 12px !important;
  border-radius: 12px !important;
  font-weight: 600;
  font-size: 13px;
  outline: none;
  transition: 0.3s;
  width: 160px;
}

.date-input-wrap input:focus {
  border-color: #a142f4 !important;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

.chart-card {
  background: white;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
}

.data-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.data-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.data-card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 15px;
  color: #2c3e50;
}

.tool-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  height: 34px;
  padding: 0 12px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: 0.2s;
}

.tool-btn:hover {
  border-color: #a142f4;
  color: #a142f4;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.data-table th {
  background: #f8fafc !important;
  padding: 12px 15px !important;
  color: #94a3b8 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #f1f2f6 !important;
  border: none !important;
  border-bottom: 1px solid #f1f2f6 !important;
}

.data-table td {
  padding: 10px 15px !important;
  border: none !important;
  border-bottom: 1px solid #f8fafc !important;
  font-size: 14px;
  color: #334155;
  vertical-align: middle;
}

.data-table tbody tr:hover {
  background: #faf8ff;
}

.id-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.empty-row {
  text-align: center;
  padding: 40px 15px !important;
  color: #94a3b8;
  font-style: italic;
}

/* MODAL */
.modal-form { padding: 10px; }
.form-unit { margin-bottom: 16px; }
.form-unit label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #95a5a6;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-input {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 12px;
  padding: 12px 15px;
  color: #2c3e50;
  font-weight: 600;
  transition: 0.3s;
}

.form-input:focus {
  background: white;
  border-color: #a142f4;
  outline: none;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.05);
}

.form-input.readonly {
  background: #f1f5f9;
  color: #64748b;
}

.modal-actions {
  padding-top: 15px;
  border-top: 1px solid #f1f2f6;
}

/* Billing xatosi uchun ogohlantirish paneli */
.pay-alert {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 12px;
  font-size: 13px;
  font-weight: 600;
}

.pay-alert-hint {
  margin-top: 6px;
  color: #92400e;
  font-weight: 500;
}

.btn-save-full:disabled,
.action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-save-full {
  background: #a142f4;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 12px;
  font-weight: 700;
  width: 100%;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.btn-save-full:hover {
  background: #8e39d9;
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .dash-page {
    padding: 10px !important;
  }
}
</style>